<template>
  <div>
    <Modal
      :id="id"
      size="lg"
      no-stacking>
      <template v-slot:modal-title>
        <span class="modal-title">Период жизни</span>
      </template>
      <template v-slot:default>
        <div class="flex flex-col space-y-8 p-8">
          <div
            class="flex flex-row space-x-4 life-dates-row"
            v-for="(v, index) in $v.value.$each.$iter"
            :key="index">
            <div class="flex-1">
              <div class="input-group">
                <label>День</label>
                <Select
                  class="bg-hint"
                  :options="days[index]"
                  v-model="v.day.$model"/>
              </div>
            </div>
            <div class="flex-1">
              <div class="input-group">
                <label>Месяц</label>
                <Select
                  class="bg-hint"
                  :options="months"
                  v-model="v.month.$model"/>
              </div>
            </div>
            <div class="flex-1">
              <div class="position-relative">
                <Input
                  :classes="$classnames(['bg-hint', {
                    'border-hint':
                      !v.year.$dirty ||
                      !v.year.$invalid,
                    'border-danger':
                      v.year.$dirty &&
                      v.year.$invalid,
                  }])"
                  label="Год"
                  v-model="v.year.$model"/>
                  <div
                    class="flex flex-col mt-1 position-absolute"
                    v-if="
                      v.year.$dirty &&
                      v.year.$invalid
                    ">
                    <small
                      class="font-rubik text-danger"
                      v-if="!v.year.required">
                        Укажите год
                    </small>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="flex space-x-2">
          <button
            class="btn btn-xs btn-outline-primary flex-grow"
            @click="$bvModal.hide(id)">Отмена</button>
          <button
            class="btn btn-xs btn-primary flex-grow"
            @click="save()">Подтвердить</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import Modal from '@/components/Modal.vue';
import Select from '@/components/Select.vue';
import Input from '@/components/Input.vue';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    payload: {
      required: true,
      validator: (obj) => typeof obj === 'object' || obj === null,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  components: {
    Modal,
    Select,
    Input,
  },
  validations() {
    if (this.value) {
      return {
        value: {
          $each: {
            day: {},
            month: {},
            year: { required },
          },
        },
      };
    }
    return {};
  },
  computed: {
    days() {
      if (!this.value) {
        return [
          [], [],
        ];
      }
      return this.value.map((date) => {
        const daysInMonth = moment({
          day: _.get(date, 'day.value') || 1,
          month: _.get(date, 'month.value') || 0,
          year: date.year,
        }).daysInMonth();
        return _.range(1, daysInMonth + 1).map((day) => ({
          label: day,
          value: day,
        }));
      });
    },
    months() {
      return moment.months().map((month, index) => ({
        label: this.$voca.capitalize(month),
        value: index,
      }));
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    save() {
      if (this.value) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return null;
        }
        let value = _.cloneDeep(this.value);
        value = value.map((d) => {
          const obj = d;
          if (d.day !== null) {
            obj.day = _.get(d, 'day.value');
          }
          if (d.month !== null) {
            obj.month = _.get(d, 'month.value');
          }
          return obj;
        });
        const bf = [];
        if (_.get(value, '[0].day') !== null) {
          bf.push('DD');
        }
        if (_.get(value, '[0].month') !== null) {
          bf.push('MM');
        } else {
          bf.splice(0, 1);
        }
        if (_.get(value, '[0].year') !== null) {
          bf.push('YYYY');
        }
        const df = [];
        if (_.get(value, '[1].day') !== null) {
          df.push('DD');
        }
        if (_.get(value, '[1].month') !== null) {
          df.push('MM');
        } else {
          df.splice(0, 1);
        }
        if (_.get(value, '[1].year') !== null) {
          df.push('YYYY');
        }
        const date = {
          birthday: moment({
            day: _.get(value, '[0].day'),
            month: _.get(value, '[0].month'),
            year: _.get(value, '[0].year'),
          }).format(bf.reverse().join('-')),
          deathday: moment({
            day: _.get(value, '[1].day'),
            month: _.get(value, '[1].month'),
            year: _.get(value, '[1].year'),
          }).format(df.reverse().join('-')),
        };
        this.$emit('input', {
          ...this.payload,
          ...date,
        });
      }
    },
  },
  watch: {
    payload: {
      // eslint-disable-next-line consistent-return
      handler(data) {
        if (!data) return null;
        const dates = [
          _.get(data, 'birthday') || null,
          _.get(data, 'deathday') || null,
        ];
        this.value = dates.map((s) => {
          const output = {
            day: null,
            month: null,
            year: null,
          };
          if (s) {
            const f = s.split('-').map((p, index) => {
              switch (index) {
                case 0:
                  return 'YYYY';
                case 1:
                  return 'MM';
                case 2:
                  return 'DD';
                default:
                  return '';
              }
            }).join('-');
            if (s) {
              const date = moment(s, f);
              if (date.isValid()) {
                if (f.indexOf('DD') > -1) { // eslint-disable-line no-underscore-dangle
                  output.day = date.date();
                }
                if (f.indexOf('MM') > -1) { // eslint-disable-line no-underscore-dangle
                  output.month = date.month();
                }
                if (f.indexOf('YYYY') > -1) { // eslint-disable-line no-underscore-dangle
                  output.year = date.year();
                }
              }
            }
            if (output.day) {
              output.day = {
                label: output.day,
                value: output.day,
              };
            }
            if (output.month) {
              output.month = _.find(this.months, (month) => month.value === output.month);
            }
          }
          return output;
        });
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(data) {
        data.map((date, index) => {
          const day = _.get(date, 'day.value') || null;
          if (day !== null) {
            const found = _.find(this.days[index], (obj) => obj.value === day);
            if (!found) {
              this.value[index].day = null;
            }
          }
          return null;
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (event, modalId) => {
      switch (modalId) {
        case this.id:
          this.$v.$reset();
          break;
        default:
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
};
</script>
